import { RestCallBuilder } from '../../../builder/rest/rest-call.builder';
import { Subscription } from 'rxjs';
import { AppConfigService } from '../../app-config.service';
import { inject } from '@angular/core';
import { OrderId } from '@web/dtos';

export class ConfirmationEmailGateway {
  private readonly orderConfirmationBuilder: RestCallBuilder<
    Record<string, never>
  > = new RestCallBuilder<Record<string, never>>({});
  private readonly configService: AppConfigService = inject(AppConfigService);

  orderConfirmationEmail(orderId: OrderId): Subscription {
    return this.orderConfirmationBuilder
      .postExternal(
        `${this.configService.get().general.directTicketUrl}/orders/${orderId}/order-confirmation-email`,
        {}
      )
      .handleMessages()
      .build()
      .subscribe();
  }
}
